import { render, staticRenderFns } from "./ColorSelector.vue?vue&type=template&id=77889837&scoped=true&"
import script from "./ColorSelector.vue?vue&type=script&lang=js&"
export * from "./ColorSelector.vue?vue&type=script&lang=js&"
import style0 from "./ColorSelector.vue?vue&type=style&index=0&id=77889837&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77889837",
  null
  
)

export default component.exports